import { eventSenderManager } from 'lib/analytics/eventSender'
import { useEffect } from 'react'
import { useSessionStore } from 'store/session'

export function AnalyticsMetadata() {
  const {
    user: { corporate, id: userId }
  } = useSessionStore()

  useEffect(() => {
    if (corporate) {
      const { corporateId, document, name } = corporate.data
      eventSenderManager.updateMetadata({
        corporateId,
        corporateDocument: document,
        corporateName: name,
        user_id: userId
      })
    }
  }, [corporate, userId])

  return null
}
